import { OppslutningTableItem } from '../Oppslutning/mapping'

const toProsent = item => item.prosent || 0
const toProsentForrige = item => (item.prosent || 0) - (item.endring || 0)
const sum = (acc, val) => acc + val

const BORGERLIGE = ['H', 'KRF', 'V', 'FRP']
const SOSIALISTISKE = ['A', 'SV', 'RØDT', 'SP', 'MDG']

class OneDecimal {
  _value: number

  constructor(value?: number) {
    if (typeof value === 'number') {
      this._value = Math.round(value * 10)
    }
  }

  get value() {
    return this._value / 10
  }

  subtract(val: OneDecimal) {
    const result = new OneDecimal()
    result._value = this._value - val._value
    return result
  }
}

export function calculateTendens(items: OppslutningTableItem[]) {
  const borgerlige = items.filter(item => BORGERLIGE.includes(item.id))
  const oppslutningBorgerlige = new OneDecimal(borgerlige.map(toProsent).reduce(sum, 0))
  const oppslutningBorgerligeForrige = new OneDecimal(
    borgerlige.map(toProsentForrige).reduce(sum, 0)
  )
  const endringBorgerlige = oppslutningBorgerlige.subtract(oppslutningBorgerligeForrige)

  const sosialistiske = items.filter(item => SOSIALISTISKE.includes(item.id))
  const oppslutningSosialistiske = new OneDecimal(sosialistiske.map(toProsent).reduce(sum, 0))
  const oppslutningSosialistiskeForrige = new OneDecimal(
    sosialistiske.map(toProsentForrige).reduce(sum, 0)
  )
  const endringSosialistiske = oppslutningSosialistiske.subtract(oppslutningSosialistiskeForrige)

  const oppslutningAndre = new OneDecimal(100)
    .subtract(oppslutningSosialistiske)
    .subtract(oppslutningBorgerlige)
  const oppslutningAndreForrige = new OneDecimal(100)
    .subtract(oppslutningSosialistiskeForrige)
    .subtract(oppslutningBorgerligeForrige)
  const endringAndre = oppslutningAndre.subtract(oppslutningAndreForrige)

  const tendens = {
    borgerlige: {
      partier: borgerlige.map(parti => parti.kortNavn),
      oppslutning: oppslutningBorgerlige.value,
      oppslutningForrige: oppslutningBorgerligeForrige.value,
      endring: endringBorgerlige.value
    },
    sosialistiske: {
      partier: sosialistiske.map(parti => parti.kortNavn),
      oppslutning: oppslutningSosialistiske.value,
      oppslutningForrige: oppslutningSosialistiskeForrige.value,
      endring: endringSosialistiske.value
    },
    andre: {
      oppslutning: oppslutningAndre.value,
      oppslutningForrige: oppslutningAndreForrige.value,
      endring: endringAndre.value
    }
  }
  return tendens
}

export type TekstProps = {
  endringBorgerlige: number
  endringSosialistiske: number
  endringAndre: number
  oppslutningBorgerlige: number
  oppslutningSosialistiske: number
  oppslutningAndre: number
  valg: string
}

export function getTekstId(props: TekstProps) {
  if (props.endringBorgerlige > 0 && props.endringSosialistiske > 0) {
    if (props.endringBorgerlige === props.endringSosialistiske) {
      return 'tendens-tekst-frem-like'
    } else if (props.endringBorgerlige > props.endringSosialistiske) {
      return 'tendens-tekst-borgerlige-og-sosialistiske-frem'
    } else {
      return 'tendens-tekst-sosialistiske-og-borgerlige-frem'
    }
  } else if (props.endringBorgerlige > 0) {
    return 'tendens-tekst-borgerlige-frem'
  } else if (props.endringSosialistiske > 0) {
    return 'tendens-tekst-sosialistiske-frem'
  } else {
    return 'tendens-tekst-ingen-frem'
  }
}
